<div class="vreb-logo" *ngIf="isVictoriaRealEstateBoard">
  <a href="https://vreb.org/vreb-idx-reciprocity-program" 
    target="_blank"
    rel="nofollow"> 
    <img class="vreb-logo-img" src="../../../../assets/icons/VREBReciprocityLogo.png"/>
  </a>
</div>


<div class="no-logo" *ngIf="!isVictoriaRealEstateBoard"> 
  <img class="no-logo-img" src="" />
</div>

<a [routerLink]="['/' + listing.detailUrl]" (click)="listingCardClicked()" (focus)="onFocus.emit($event)" [class.listing-details]="isListingDetails">

  <div class="cara-logo-card-container" *ngIf="isCaraBoard">
    <img  src="../../../../assets/icons/CaraIcon.png" class="cara-logo-card" />
  </div>

  <div [jsonSchema]="listing.jsonLdSchema"></div>
  <div (mouseenter)="onHoverListingCard.emit({action: 'enter', listingId: listing.id})" (mouseleave)="onHoverListingCard.emit({action: 'leave', listingId: listing.id})"
     class="listing-card has-address" #card
     [class.selected]="highlight"
     [class.luxury]="listing.isLuxury"
     [class.commercial]="listing.isCommercial"
     [class.listing-details]="isListingDetails">
    <div class="listing-card-images" *ngIf="!showMap">
      <app-rm-carousel [isListingDetails]="isListingDetails"
                       [images]="listing.imageUrls"
                       [isSelectedCarousel]="isSelectedCard"
                       [showHighDprImages]="screenSize < SCREEN_SIZE.DESKTOP_UP"
                       [shouldPrefetch]="screenSize <= SCREEN_SIZE.MOBILE_ONLY && (isMapView || isListingDetails)"
                       [isCommercial]="listing.isCommercial"
                       [isLuxury]="listing.isLuxury"
                       (onChangeCarouselIndex)="changeCarouselIndex.emit($event)"
                       (onImageClick)="listingCardClicked(true)"
                       [currentSlideIndex]="currentSlideIndex"
                       [isNextCarousel]="isNextCard"
                       carouselParentName="listing-card">       
      </app-rm-carousel>
    </div>
    <div class="listing-map" *ngIf="showMap">
      <app-map [listing]="listing" [isLDP]="isListingDetails"></app-map>
    </div>

    <section class="card-text">
      <div class="courtesy is-flex has-flex-align-center" style="white-space: normal;">
          <!-- TODO: Handle multi line ellipsis -->
        <span>{{listing | courtesyMessage}}</span>
      </div>
      <div class="mlsNumber">
        <span *ngIf="listing.mlsNum">{{ 'details.mls-num' | translate }}: </span>
        <span *ngIf="listing.mlsNum">{{ listing.mlsNum }}</span>
      </div>
      <ng-container *ngIf="!isListingDetails || (!listing.isLuxury)">
        <div class="content has-pos-rel is-flex has-flex-content-start">
          <app-listing-flags *ngIf="!isListingDetails" [listing]="listing"></app-listing-flags>
          <div class="left-content flex-one">
            <h3 class="price">
              <span></span>
              {{ priceOrPricePerSqFt }} <app-listing-price-arrow [listPriceMove]="listing.listPriceMove" [width]="12" [color]="listing.isLuxury?'white':'gray'"></app-listing-price-arrow>
            </h3>
            <p class="address" *ngIf="includeAddress">
              <app-listing-address [parts]="[listing.address, listing.city, listing.province, listing.postalCode | formatPostalCode]"></app-listing-address>
            </p>
          </div>
          <div class="actions is-flex has-flex-align-center">
            <img [src]="listing.favouriteIconToUse | staticp" tabindex="0" (keydown.enter)="toggleFavourite($event)" (focus)="onFocus.emit($event)"
              [title]="('gallery.aria.' + (listing.isFavourite ? 'unfavourite' : 'favourite')) | translate"
              class="" (click)="toggleFavourite($event)" height="18" width="17" role="button"/>
          </div>
        </div>
        <div class="content-bottom is-flex">
          <app-property-details [listing]="listing"></app-property-details>
          <ng-content></ng-content>
        </div>
      </ng-container>
      <ng-container *ngIf="isListingDetails">
        <div *ngIf="listing.isLuxury" class="luxury-content-wrapper">
          <div class="luxury-content text-center has-pos-rel">
            <div class="is-flex has-flex-content-center">
              <h3 class="price"> {{listing.listPrice | currency:'CAD':'symbol-narrow':'1.0-0'}} <app-listing-price-arrow [listPriceMove]="listing.listPriceMove" [width]="12" [color]="listing.isLuxury?'white':'gray'"></app-listing-price-arrow></h3>
              <img [src]="listing.favouriteIconToUse | staticp"
                [title]="('gallery.aria.' + (listing.isFavourite ? 'unfavourite' : 'favourite')) | translate"
                class="" (click)="toggleFavourite($event)" height="20" width="20" role="button"/>
            </div>
            <app-property-details [listing]="listing" [isListingDetails]="isListingDetails"></app-property-details>
          </div>
        </div>
      </ng-container>
    </section>
  </div>
</a>
